import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { StampsState, StampsStore } from './stamps.store';

@Injectable({ providedIn: 'root' })
export class StampsQuery extends QueryEntity<StampsState> {
  /** Observable array of stamps. */
  stamps$ = this.selectAll();

  constructor(protected store: StampsStore) {
    super(store);
  }
}
